module.exports = __webpack_public_path__ + "static/open-sans-regular-049a929c5d81988b3ae6d2f985ca7aa5.ttf";